<template>
    <div class="ppv2-space-y-3 !ppv2-mb-4">
        <div class="v3-section-title mb-2">
            <span>{{ $t('staff_planning_v3.components.note_section.title') }}</span>
        </div>

        <BaseTextarea
            :value="value"
            @input="$emit('input', $event)"
            :rows="1"
            :useEditor="false"
            :placeholder="$t('staff_planning_v3.components.note_section.placeholder')"
        />
    </div>
</template>

<script>
import BaseTextarea from '../../../Shared/BaseTextarea.vue'

export default {
    name: 'NoteSection',
    components: {
        BaseTextarea,
    },
    props: {
        value: {
            type: String,
            default: '',
        },
    },
}
</script>
